module.exports = __webpack_public_path__ + "img/Rajesh.cd6d7f14.jpg";